


























import { Component, Mixins, Prop } from "vue-property-decorator";
import { CacheableComponent } from "../../../base/components/system";
import { ModelEditableMixin, TabContainableMixin } from "../../../base/components/system/mixins";
import { TabSelector } from "../../../base/components/system/selectors";
import { EditableFormatSummary } from "../../domain/editableFormat";
import { FormatTranslatorTestTool, FormatsTestTool } from "./contents";

@Component({
  components: {
    TabSelector,
    CacheableComponent,
    FormatTranslatorTestTool,
    FormatsTestTool,
  }
})
export default class FormatListViewerDebugTool extends Mixins(ModelEditableMixin, TabContainableMixin) {
  static readonly Tabs: {[key: string]: any} = {
    translator: {
      name: "フォーマット変換",
      description: "選択したフォーマットのソース/エンティティ変換/逆変換を行い比較結果を表示する。",
    },
    formatsValidation: {
      name: "複数フォーマット検証",
      description: "選択したフォルダのフォーマットの検証を行う。",
    }
  };
  // vmのメンバでないとテンプレートからバインドできないのでフィールドとして定義.(変化しないのでリアクティブじゃなくていい.)
  readonly translatorTab: any = FormatListViewerDebugTool.Tabs.translator;
  readonly formatsValidationTab: any = FormatListViewerDebugTool.Tabs.formatsValidation;

  @Prop()
  formats: EditableFormatSummary[];

  @Prop()
  format: EditableFormatSummary;

  mounted(): void {
    this.initializeTabs();
  }

  initializeTabs(): void {
    this.tabs = [
      this.translatorTab,
      this.formatsValidationTab,
    ];
    this.selectedTab = null;
  }

  get formatName(): string {
    return this.editingSource.attributes.format.name;
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  replaceWording(text: string): string {
    return text.replace(/フォーマット/g, this.formatNameWording);
  }
}
